import { Trans, useTranslation } from "react-i18next";

import type { NotificationContentProps } from "../../types";

export default function AssessorAssignedContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  const allIdeas = events.flatMap((event) => event?.ownerIdeas || []);
  const { t } = useTranslation();

  return (
    <Trans
      i18nKey="notifications.assessorAssigned"
      values={{
        ideaLabel: allIdeas.length > 1 ? t("generic.ideas") : t("generic.idea"),
        ideas: allIdeas.map((idea) => idea?.name || "[Deleted]").join(" "),
        challenge: ownerChallenge?.name || "Deleted",
      }}
    />
  );
}
